import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { getThemeClass } from '../../../../utils/theme';

const PostPreview = ({ 
  post,
  theme = 'dark' 
}) => {
  if (!post) {
    return (
      <div className={`h-full flex items-center justify-center ${getThemeClass(theme, 'text.secondary')}`}>
        No content to preview
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className={`flex-none px-3 py-2 border-b ${getThemeClass(theme, 'border')} 
        ${getThemeClass(theme, 'text.secondary')} text-sm font-medium`}>
        Preview
      </div>
      <div className="flex-1 min-h-0 overflow-auto p-6 bg-slate-900">
        {/* Post Header */}
        <div className="mb-6 pb-4 border-b border-slate-700">
          <h1 className="text-2xl font-bold text-white mb-2">
            {post.title || 'Untitled Post'}
          </h1>
          {post.excerpt && (
            <p className="text-slate-400 text-sm">{post.excerpt}</p>
          )}
        </div>

        {/* Post Content */}
        <div className="prose prose-invert prose-slate max-w-none
          prose-headings:text-white 
          prose-p:text-slate-300 
          prose-a:text-blue-400
          prose-strong:text-white
          prose-code:text-amber-300
          prose-pre:bg-slate-800
          prose-blockquote:border-blue-500
          prose-li:text-slate-300">
          <ReactMarkdown 
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
          >
            {post.content || '*No content yet*'}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default PostPreview;









